<template>
  <pt-detection-package-table class="pt-detection-package-table__withData" :request-data="getDataList" :page-size="pageSize"
  :total-number="Number(totalNumber)" :table-data="tableData" :tableLabels="tableLabels" ref="table" :isOutside="isOutside">
  <template slot-scope="scope">
      <slot :row="scope.row"></slot>
    </template>
  </pt-detection-package-table>
</template>

<script>
import PtDetectionPackageTable from './index'
// import { isEmptyObject } from '@/utils/formUtils'
export default {
  name: 'pt-detection-package-table__withData',
  components: {
    'pt-detection-package-table': PtDetectionPackageTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: () => []
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pageSize: 10,
      totalNumber: 0,
      tableData: [],
      currentParams: this.paramsData,
      isOutside: false
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
          this.currentParams = val
          this.resetPage()
        } else {
          this.isOutside = true
          this.currentParams = val
          this.getDataList(this.page)
        }
        // this.currentParams = val
        // this.getDataList(0)
      },
      deep: true
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getDataList (page, next) {
      let data = {
        page: page,
        size: this.pageSize,
        sort: 'id,desc',
        ...this.currentParams
      }
      this.$store.dispatch('getDetectionPackageList', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    },
    // 筛选数据的参数,不传默认为{}
    reload (params = {}) {
      this.currentParams = params
      this.$refs.table.reload()
    }
  }
}
</script>
